import { relations } from "drizzle-orm";
import {
  bigint,
  mysqlEnum,
  mysqlTable,
  timestamp,
  varchar,
} from "drizzle-orm/mysql-core";
import { user } from "../better-auth/auth-schema";

export const invoice = mysqlTable("invoice", {
  id: bigint("id", { mode: "number" }).primaryKey().autoincrement(),
  stripeInvoiceId: varchar("stripe_invoice_id", { length: 255 }).notNull(),
  status: mysqlEnum("status", [
    "draft",
    "open",
    "paid",
    "void",
    "uncollectible",
  ])
    .notNull()
    .default("draft"),
  amount: bigint("amount", { mode: "number" }).notNull(), // Amount in cents
  currency: varchar("currency", { length: 3 }).notNull().default("USD"),
  userId: bigint("user_id", { mode: "number" }).notNull(),
  description: varchar("description", { length: 1000 }),
  createdAt: timestamp("created_at").notNull().defaultNow(),
  paidAt: timestamp("paid_at"),
  voidedAt: timestamp("voided_at"),
});

export const invoiceRelations = relations(invoice, ({ one }) => ({
  user: one(user, {
    fields: [invoice.userId],
    references: [user.id],
  }),
}));
